var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isLoggedIn
        ? _c(
            "b-navbar",
            {
              staticStyle: { "margin-left": "0px !important" },
              attrs: { type: "dark", variant: "dark", fixed: "top" }
            },
            [
              _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
              _vm._v(" "),
              _c("b-navbar-brand", [_vm._v("PLATFORM")])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c("b-row", [
            _c(
              "div",
              { staticClass: "Absolute-Center is-Responsive" },
              [
                _c(
                  "b-alert",
                  {
                    attrs: {
                      variant: "danger",
                      dismissible: "",
                      show: _vm.showDismissibleAlert
                    },
                    on: {
                      dismissed: function($event) {
                        _vm.showDismissibleAlert = false
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.loginErrorMessage) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-md-10 col-md-offset-1" },
                  [
                    _c(
                      "b-form",
                      {
                        attrs: { id: "loginForm" },
                        on: {
                          submit: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.login()
                          }
                        }
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "usernameGroup",
                              label: _vm.$t("message.login.login"),
                              "label-for": "usernameInput"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "usernameInput",
                                type: "text",
                                placeholder: _vm.$t("message.login.enterLogin")
                              },
                              model: {
                                value: _vm.username,
                                callback: function($$v) {
                                  _vm.username = $$v
                                },
                                expression: "username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "passwordGroup",
                              label: _vm.$t("message.login.password"),
                              "label-for": "passwordInput"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "passwordInput",
                                type: "password",
                                placeholder: _vm.$t(
                                  "message.login.enterPassword"
                                )
                              },
                              model: {
                                value: _vm.password,
                                callback: function($$v) {
                                  _vm.password = $$v
                                },
                                expression: "password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "submit",
                                  variant: "dark",
                                  block: ""
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("message.login.signIn")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6faab3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6faab3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Authorization/Login.vue
// module id = null
// module chunks = 